// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/prop-types */
import React from 'react';
import { graphql } from 'gatsby';
import { parseMarkdown } from '../utils/parse-md';
import { DefaultLayout } from '../layouts/default';
import { parseMarkdownUK } from '../utils/parse-md-uk';

// markup
const PrivacyPolicyPage = ({ data }) => {
	const containerStyle = {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '30vh',
		width: '100vw',
		backgroundImage: `url(https://www.datocms-assets.com/64336/1712342621-hero_privacy.jpg)`,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
	};

	const contentStyle = {
		textAlign: 'center',
		color: 'white',
		fontSize: '2.5em',
		margin: '1em',
	};
	const contentMD = data.datoCmsPrivacyPolicy.content;
	const { locale } = data.datoCmsPrivacyPolicy;
	const parsedMD =
		locale === 'en' ? parseMarkdownUK(contentMD) : parseMarkdown(contentMD);
	return (
		<>
			<div style={containerStyle}>
				<div style={contentStyle}>
					<h1>Privacy Policy</h1>
				</div>
			</div>
			<div className="max-w-7xl mx-auto text-lg lg:text-justify md:p-8 p-3 leading-normal flex flex-wrap overflow-auto !sm:text-sm">
				<div
					dangerouslySetInnerHTML={{ __html: parsedMD }}
					className="break-words table td legal"
				/>
			</div>
		</>
	);
};

const WrappedPrivacyPolicy = ({ data }) => (
	<DefaultLayout
		siteSettings={data.siteSettings}
		navigation={data.navItems}
		footerData={data.footerItems}
	>
		<PrivacyPolicyPage data={data} />
	</DefaultLayout>
);

export default WrappedPrivacyPolicy;

export const query = graphql`
	query PrivacyPolicyQuery($locale: String!) {
		siteSettings: datoCmsSiteSpecificSetting(locale: { eq: $locale }) {
			...siteSettings
		}
		navItems: datoCmsSiteSpecificSetting(locale: { eq: $locale }) {
			...navItems
		}
		footerItems: datoCmsSiteSpecificSetting(locale: { eq: $locale }) {
			...footerItems
		}
		datoCmsPrivacyPolicy(locale: { eq: $locale }) {
			content
			locale
		}
	}
`;
